import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  HrFlexContainer,
  HrTitleContainer,
  HrTitleH4,
  HrButtons,
  HrParagraph,
  HrFontBold
} from '@components/styles/hr-styles';
import { HrButton } from '@components/button/button';
import { Modal } from '../../../postulation_form/components/modal';

export const ApproveRequestModal = ({ actualRowId, approve, setShowModalApproveRequest }) => {
  const [t] = useTranslation();

  const handleApproveRequest = () => {
    approve.mutate({ idRequisition: actualRowId });
  };

  return (
    <Modal setShowModal={setShowModalApproveRequest}>
      <HrTitleContainer padding='32px 32px 12px 32px' gap='4px'>
        <i className='hr-Checkmark' style={{ fontSize: '20px' }} />
        <HrTitleH4>{t('requestVacancies.colaborativeSelection.modal.approveRequest.title')}</HrTitleH4>
      </HrTitleContainer>
      <HrFlexContainer padding='16px 32px 0 32px' gap='8px'>
        <HrParagraph fontWeight={HrFontBold}>
          {t('requestVacancies.colaborativeSelection.modal.approveRequest.subTitle')}
        </HrParagraph>
        <HrParagraph>{t('requestVacancies.colaborativeSelection.modal.approveRequest.clarification')}</HrParagraph>
        <HrFlexContainer flexDirection='column' style={{ alignContent: 'flex-start' }}>
          <HrParagraph fontWeight={600}>Además se creará de forma automática una:</HrParagraph>
          <HrParagraph
            padding='8px'
            color='#3b3f51'
            fontWeight={600}
            style={{
              backgroundColor: '#f4f4f4',
              borderRadius: '4px',
              alignSelf: 'flex-start',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
          >
            {' '}
            <i className='hr-File hrc-fw-600' />
            Vacante borrador
          </HrParagraph>
        </HrFlexContainer>
      </HrFlexContainer>
      <HrFlexContainer padding='32px' justifyContent='flex-end' gap='8px'>
        <HrButtons
          type='button'
          category='cancel'
          size='medium'
          onClick={() => {
            setShowModalApproveRequest(false);
          }}
        >
          {t('general.button.close')}
        </HrButtons>
        <HrButton
          type='button'
          category='primary'
          size='medium'
          onClick={handleApproveRequest}
          loading={approve.isLoading}
          disabled={approve.isLoading}
          text={t('general.button.approve')}
          name='approve'
        />
      </HrFlexContainer>
    </Modal>
  );
};
